/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Seat_Price_New_SeatInputs */



/**
* | output |
* | --- |
* | "A new {type} seat is bought for the rest of this billing period." |
*
* @param {Seat_Price_New_SeatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_new_seat = /** @type {((inputs: Seat_Price_New_SeatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_New_SeatInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein neuer ${i?.type}-Platz wird für den Rest dieses Abrechnungszeitraums gekauft.`)
	return /** @type {LocalizedString} */ (`A new ${i?.type} seat is bought for the rest of this billing period.`)
});